import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export type FeaturedCoupon = {
  code: string;
  discount_type: string;
  discount_value: number;
  applies_to: string;
  expires_at: string | null;
  description: string | null;
};

/**
 * Fetches the best-deal featured coupon for a given shop via the
 * security-definer function `get_featured_shop_codes`.
 */
export function useFeaturedCoupon(shop: "premade" | "coloring" | "custom") {
  return useQuery({
    queryKey: ["featured-coupon", shop],
    queryFn: async () => {
      const { data, error } = await supabase.rpc("get_featured_shop_codes", {
        _shop: shop,
      });
      if (error) throw error;
      if (!data || (data as any[]).length === 0) return null;
      return (data as any[])[0] as FeaturedCoupon;
    },
    staleTime: 60_000, // 1 min
  });
}

/** Check if ANY shop has a featured coupon (for home page badges). */
export function useFeaturedCouponsAll() {
  const shops = ["premade", "coloring", "custom"] as const;

  const premade = useFeaturedCoupon("premade");
  const coloring = useFeaturedCoupon("coloring");
  const custom = useFeaturedCoupon("custom");

  return {
    premade: premade.data,
    coloring: coloring.data,
    custom: custom.data,
    isLoading: premade.isLoading || coloring.isLoading || custom.isLoading,
  };
}
